export default __webpack_public_path__ + "media/images/portfolio/width-600/portfolio-17-c7e88f85293935f297c6964dd97cee78.jpg";